
import { RQ } from 'utils';
import XAddress from 'vux/src/components/x-address/index.vue'


export default {
name: 'address-select',
props: {
title: {
type: String,
default: '省市区'
},
placeholder: {
type: String,
default: '请选择'
},
value: {
type: Array,
default: function () {
return [];
}
}
},
created: async function () {
const d = await RQ.mall.get('/api/c/sysAddress/getAddress', {});
if (d && d.code == 0) {
this.addressData = d.data;
}
if (this.value.length != 0) {
this.addressValue = this.value;
}
},
data() {
return {
addressData: [],
addressValue: [],
zIndex: { 'z-index': 99999 },
showAddress: false
};
},
methods: {
onHide(confirm) {
if (confirm) {
this.$emit('confirm', this.addressValue);
} else {
this.$emit('cancel', this.addressValue);
}
},
onShow(str) {

}
},
components: {
XAddress
}
};



// WEBPACK FOOTER //
// ./src/components/addressSelect.vue